import { g as getEnvVariable } from "./index-Jj5pKhlE.js";
import { b as isWindowDefined, c as isFalsyFilter } from "./index-CJNq9Per.js";
import { b as SUPPORTED_FILTER_KEYS, c as MAX_OFFER_CARDS, V as VARIANTS, D as DEFAULT_FILTER_KEY, d as DEFAULT_FILTER_VALUE } from "./index-WXBJjodC.js";
const getDataLayer = () => {
  return isWindowDefined() ? window.ql_dl : null;
};
const getVisibleOffers = (variant, maxOffers, offers) => {
  const defaultMax = MAX_OFFER_CARDS[variant] || MAX_OFFER_CARDS[VARIANTS.FULL];
  if (maxOffers > defaultMax) {
    console.warn(`The maxOffers value (${maxOffers}) exceeds the allowed limit (${defaultMax}) for the ${variant} variant.`);
  }
  const maxOfferCards = Math.min(maxOffers || defaultMax, defaultMax);
  return offers.slice(0, maxOfferCards);
};
const getOffersAPI = ({ environment, filters }) => {
  const offersAPI = getEnvVariable({
    currentEnv: environment,
    keyToSearch: "GET_OFFERS_API"
  });
  const queryParams = filters.filter(({ key }) => SUPPORTED_FILTER_KEYS.includes(key)).map(({ key, value }) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
  return queryParams ? `${offersAPI}?${queryParams}` : offersAPI;
};
const getDefaultFilters = (filters) => {
  if (!Array.isArray(filters)) {
    return [];
  }
  const index = filters.findIndex((filter) => filter.key === DEFAULT_FILTER_KEY);
  if (index === -1) {
    filters.push({ key: DEFAULT_FILTER_KEY, value: DEFAULT_FILTER_VALUE });
  } else if (isFalsyFilter(filters[index].value)) {
    filters[index].value = DEFAULT_FILTER_VALUE;
  }
  return filters;
};
export {
  getDefaultFilters as a,
  getOffersAPI as b,
  getVisibleOffers as c,
  getDataLayer as g
};
//# sourceMappingURL=marketplace-BNakCyBo.js.map
